import React from 'react';
import {
  BaseEdge,
  EdgeLabelRenderer,
  getBezierPath,
  type EdgeProps,
  type Edge,
} from '@xyflow/react';

import type { RetrievalGraphEdgeData } from '../../../types/retrieval';

const RelationshipEdge: React.FC<EdgeProps<Edge<RetrievalGraphEdgeData>>> = ({
  id,
  sourceX,
  sourceY,
  sourcePosition,
  targetX,
  targetY,
  targetPosition,
  data,
}) => {
  const [path, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const label = (data?.relationshipType || 'RELATED_TO')
    .toLowerCase()
    .split('_')
    .map((chunk: string) => chunk.charAt(0).toUpperCase() + chunk.slice(1))
    .join(' ');

  return (
    <>
      <BaseEdge id={id} path={path} />
      <EdgeLabelRenderer>
        <div
          className="nodrag nopan rounded border border-neutral-200 bg-white/95 px-1.5 py-0.5 text-[10px] text-neutral-500 shadow-sm"
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
            pointerEvents: 'none',
          }}
        >
          {label}
        </div>
      </EdgeLabelRenderer>
    </>
  );
};

export default React.memo(RelationshipEdge);
